import CampaignFaqs from '@cohort/components-xps/components/CampaignFaqs';
import type {PerkCard as PerkCardType} from '@cohort/components-xps/components/cards/PerkCard';
import PerkCard from '@cohort/components-xps/components/cards/PerkCard';
import ExpandableDesc from '@cohort/components-xps/components/ExpandableDesc';
import {Footer} from '@cohort/wallet/components/Footer';
import PerksGrid from '@cohort/wallet/components/layout/PerksGrid';
import SectionTitle from '@cohort/wallet/components/SectionTitle';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {CampaignStoreWDto} from '@cohort/wallet-schemas/campaign';
import React from 'react';
import {useTranslation} from 'react-i18next';

type CampaignContentDesktopProps = {
  campaign: CampaignStoreWDto;
};

export const CampaignContentDesktop: React.FC<CampaignContentDesktopProps> = ({campaign}) => {
  const {t} = useTranslation('components', {keyPrefix: 'campaignContentDesktop'});
  const {hasDarkBg, backgroundColor, accentColor} = useThemeContext();

  return (
    <div className="flex h-full flex-row">
      <div className="w-full space-y-10">
        {campaign.store.description.length > 0 && (
          <div data-testid="store-campaign-description">
            <SectionTitle content={t('descriptionSectionTitle')} />
            <ExpandableDesc
              hasDarkBg={hasDarkBg}
              backgroundColor={backgroundColor}
              description={campaign.store.description}
            />
          </div>
        )}

        {campaign.perks.length > 0 && (
          <div data-testid="store-perks-list">
            <SectionTitle content={t('perksSectionTitle')} />
            <PerksGrid>
              {campaign.perks.map(perk => {
                const perkCard = {
                  perkVideoFileKey: perk.videoFileKey ?? null,
                  perkThumbnailFileKey: perk.thumbnailFileKey ?? null,
                  perkDisplayName: perk.displayName,
                  canBeUsed: undefined,
                  digitalAssetImageFileKey: null,
                  perkBannerFileKey: perk.bannerFileKey,
                  hasDarkBg,
                  accentColor,
                  raffleStatus: undefined,
                  statusMessage: undefined,
                } satisfies PerkCardType;

                return <PerkCard key={perk.id} perkCard={perkCard} />;
              })}
            </PerksGrid>
          </div>
        )}

        {(campaign.faqs.length > 0 || campaign.merchant.supportEmail !== null) && (
          <div data-testid="store-faq-list">
            <SectionTitle content={t('faqSectionTitle')} />
            <CampaignFaqs
              faqs={campaign.faqs}
              accentColorCode={accentColor}
              hasDarkBg={hasDarkBg}
              supportEmail={campaign.merchant.supportEmail}
            />
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
};
